import getExtensibilityState from "../store/getExtensibilityState";
import { getExtensibilityStore, getMultiAccountStore, isExtensibilityStoreInitialized, isMultiAccountStoreInitialized, } from "../store/store";
import type TaskPaneRunningInstance from "../store/schema/TaskPaneRunningInstance";
import type TaskPaneType from "../store/schema/TaskPaneType";
import getTabIdFromWindow from "../store/getTabIdFromWindow";
import type { MailboxInfo } from "owa-client-types";
import { isAddinMultiAccountEnabled } from "owa-feature-flags";

export function getTaskPaneRunningInstance(type: TaskPaneType, targetWindow: Window, mailboxInfo: MailboxInfo): TaskPaneRunningInstance {
    const { taskPanes } = getExtensibilityState(mailboxInfo);
    const tabId: string = getTabIdFromWindow(targetWindow);
    
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (18,5): Type 'TaskPaneRunningInstance | undefined' is not assignable to type 'TaskPaneRunningInstance'.
    // @ts-expect-error
    return taskPanes?.get(tabId)?.get(type);
}

export function getTaskPaneRunningInstanceByControlId(controlId: string, mailboxInfo: MailboxInfo): TaskPaneRunningInstance {
    const { taskPanes } = getExtensibilityState(mailboxInfo);
    if (!taskPanes) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (27,9): Type 'null' is not assignable to type 'TaskPaneRunningInstance'.
        // @ts-expect-error
        return null;
    }
    
    for (const taskPaneAddins of taskPanes.values()) {
        for (const instance of taskPaneAddins.values()) {
            if (instance && instance.controlId === controlId) {
                return instance;
            }
        }
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (40,5): Type 'null' is not assignable to type 'TaskPaneRunningInstance'.
    // @ts-expect-error
    return null;
}

export function getTaskPaneType(controlId: string, mailboxInfo: MailboxInfo): TaskPaneType {
    const { taskPanes } = getExtensibilityState(mailboxInfo);
    if (!taskPanes) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (49,9): Type 'null' is not assignable to type 'TaskPaneType'.
        // @ts-expect-error
        return null;
    }
    
    for (const taskPaneAddins of taskPanes.values()) {
        for (const [type, taskPaneInstance] of taskPaneAddins) {
            if (taskPaneInstance && taskPaneInstance.controlId === controlId) {
                return type;
            }
        }
    }
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (62,5): Type 'null' is not assignable to type 'TaskPaneType'.
    // @ts-expect-error
    return null;
}

export function getConverseTaskPaneType(type: TaskPaneType): TaskPaneType {
    return type === "Persistent" ? "NonPersistent" : "Persistent";
}

export function findTaskPanesByWindow(targetWindow: Window): Map<TaskPaneType, TaskPaneRunningInstance> | undefined {
    const tabId = getTabIdFromWindow(targetWindow);
    if (!isAddinMultiAccountEnabled()) {
        // Skip reading (and thus creating) the store when it does not exist yet: no store means no
        // task panes, and creating it here would run during render. See store.ts for details.
        if (!isExtensibilityStoreInitialized()) {
            return undefined;
        }
        return getExtensibilityStore().taskPanes.get(tabId);
    }
    if (!isMultiAccountStoreInitialized()) {
        return undefined;
    }
    for (const state of getMultiAccountStore().values()) {
        const panes = state.taskPanes.get(tabId);
        if (panes && panes.size > 0) {
            return panes;
        }
    }
    return undefined;
}
